// extracted by mini-css-extract-plugin
export default {"buttons":"ConfigureTos_buttons__cE16g"};